<div class="timepicker-drop-down">
  <div
    class="timepicker-elements timepicker-drop-down-hour"
    [ngClass]="'timepicker-' + randomID + '-' + timepickerID + '-hour'"
    (scroll)="scrollHandler($event, 'hour')"
  >
    <ng-container *ngFor="let hour of hours">
      <div
        (click)="changeHour(hour)"
        [class.selectedTime]="hour === selectedTime.hr"
        [ngClass]="'timepicker-' + randomID + '-' + timepickerID + '-hour-' + hour"
      >
        <span>{{ hour }}</span>
      </div>
    </ng-container>
  </div>
  <div
    class="timepicker-elements timepicker-drop-down-minute"
    [ngClass]="'timepicker-' + randomID + '-' + timepickerID + '-minute'"
    (scroll)="scrollHandler($event, 'minute')"
  >
    <ng-container *ngFor="let minute of minutes">
      <div
        (click)="changeMinute(minute)"
        [class.selectedTime]="minute === selectedTime.min"
        [ngClass]="'timepicker-' + randomID + '-' + timepickerID + '-minute-' + minute"
      >
        <span>{{ minute }}</span>
      </div>
    </ng-container>
  </div>
</div>
